import React from 'react';
import { Link } from 'react-router-dom';
interface RichTextProps {
  text: string;
}
const LINK_PATTERN = /\[([^\]]+)\]\(([^)]+)\)/g;
export function RichText({
  text
}: RichTextProps) {
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  const pattern = new RegExp(LINK_PATTERN);
  while ((match = pattern.exec(text)) !== null) {
    if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index));
    parts.push(<Link key={`${match[2]}-${match.index}`} to={match[2]} className="font-semibold text-brand underline decoration-2 underline-offset-4 transition-colors duration-150 hover:text-brand-hover" data-id="element-838" data-mp="2roxe2lv5jcq1">
        {match[1]}
      </Link>);
    lastIndex = match.index + match[0].length;
  }
  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return <>{parts}</>;
}